import { useContext } from 'react';
import { CalendarContext } from '../../contexts/CalendarContext';
import { useTimezoneMonth } from '../useTimezoneMonth';

export const useMonth = (date: Date) => {
    const { timezone } = useContext(CalendarContext);
    const month = useTimezoneMonth(date, timezone);
    return month;
};
